import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SystemPermission } from '../../../model/src/lib/system-permission.model';
import { UserProfile } from '../../../model/src/lib/user-profile.model';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  private currentUserSubject$: BehaviorSubject<UserProfile | null>;
  private currentSystemPermissionsSubject$: BehaviorSubject<SystemPermission[]>;
  constructor() {
    this.currentUserSubject$ = new BehaviorSubject<UserProfile | null>(null);
    this.currentSystemPermissionsSubject$ = new BehaviorSubject<
      SystemPermission[]
    >([]);
  }

  get currentUserSubject(): BehaviorSubject<UserProfile | null> {
    return this.currentUserSubject$;
  }

  get currentSystemPermissionsSubject(): BehaviorSubject<SystemPermission[]> {
    return this.currentSystemPermissionsSubject$;
  }

  /**
   * @description 登入使用者基本資料 Observable 物件
   */
  get currentUser(): Observable<UserProfile | null> {
    return this.currentUserSubject.asObservable();
  }

  /**
   * @description 登入使用者基本資料
   */
  get currentUserValue(): UserProfile | null {
    return this.currentUserSubject.value;
  }

  /**
   * @description 登入使用者授權資料 Observable 物件
   */
  get currentSystemPermissions(): Observable<SystemPermission[]> {
    return this.currentSystemPermissionsSubject.asObservable();
  }

  /**
   * @description 登入使用者授權資料
   */
  get currentSystemPermissionsValue(): SystemPermission[] {
    return this.currentSystemPermissionsSubject.value;
  }
}
